module.exports = __webpack_public_path__ + "img/bg1.98191d32.jpg";